import React, { useState } from 'react';
import { firestore, doc, setDoc } from '../firebase-config';
import '../styles/Eventseditor.css';

const EventsEditor = ({ initialEvents = [], onSave }) => {
  const [events, setEvents] = useState(
    initialEvents.length > 0 ? initialEvents : []
  );
  const [saving, setSaving] = useState(false);

  const handleEventChange = (index, field, value) => {
    const newEvents = [...events];
    newEvents[index] = { ...newEvents[index], [field]: value };
    setEvents(newEvents);
    onSave(newEvents);
  };

  const addEvent = () => {
    const newEvent = {
      title: '',
      date: '',
      time: '',
      location: '',
      description: ''
    };
    setEvents([...events, newEvent]);
  };

  const removeEvent = (index) => {
    const newEvents = events.filter((_, i) => i !== index);
    setEvents(newEvents);
    onSave(newEvents);
  };

  const moveEventUp = (index) => {
    if (index === 0) return;
    const newEvents = [...events];
    [newEvents[index - 1], newEvents[index]] = [newEvents[index], newEvents[index - 1]];
    setEvents(newEvents);
    onSave(newEvents);
  };

  const moveEventDown = (index) => {
    if (index === events.length - 1) return;
    const newEvents = [...events];
    [newEvents[index], newEvents[index + 1]] = [newEvents[index + 1], newEvents[index]];
    setEvents(newEvents);
    onSave(newEvents);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const eventsRef = doc(firestore, 'pageContent', 'events');
      await setDoc(eventsRef, { events }, { merge: true });
      alert('Events saved successfully!');
    } catch (error) {
      console.error('Save error:', error);
      alert('Error saving events: ' + error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="events-editor">
      <div className="events-editor-header">
        <h2>Manage Special Events</h2>
        <button onClick={addEvent} className="add-event-button">
          + Add Event
        </button>
      </div>

      {events.length === 0 ? (
        <p className="no-events-message">No events yet. Click "Add Event" to create one.</p>
      ) : (
        <div className="events-editor-list">
          {events.map((event, index) => (
            <div key={index} className="event-editor-card">
              <div className="event-editor-header">
                <h3>Event {index + 1}</h3>
                <div className="event-controls">
                  <button
                    onClick={() => moveEventUp(index)}
                    disabled={index === 0}
                    className="move-button"
                    title="Move up"
                  >
                    ↑
                  </button>
                  <button
                    onClick={() => moveEventDown(index)}
                    disabled={index === events.length - 1}
                    className="move-button"
                    title="Move down"
                  >
                    ↓
                  </button>
                  <button
                    onClick={() => removeEvent(index)}
                    className="remove-event-button"
                  >
                    Remove
                  </button>
                </div>
              </div>

              <div className="event-editor-form">
                <div className="form-group">
                  <label>Event Title *</label>
                  <input
                    type="text"
                    value={event.title}
                    onChange={(e) => handleEventChange(index, 'title', e.target.value)}
                    placeholder="e.g., Sunday Service, Bible Study"
                    className="form-input"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Date *</label>
                    <input
                      type="date"
                      value={event.date}
                      onChange={(e) => handleEventChange(index, 'date', e.target.value)}
                      className="form-input"
                    />
                  </div>

                  <div className="form-group">
                    <label>Time</label>
                    <input
                      type="time"
                      value={event.time}
                      onChange={(e) => handleEventChange(index, 'time', e.target.value)}
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Location</label>
                  <input
                    type="text"
                    value={event.location}
                    onChange={(e) => handleEventChange(index, 'location', e.target.value)}
                    placeholder="e.g., Main Sanctuary, Fellowship Hall"
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    value={event.description}
                    onChange={(e) => handleEventChange(index, 'description', e.target.value)}
                    placeholder="Brief description of the event"
                    className="form-textarea"
                    rows="3"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <button
        onClick={handleSave}
        disabled={saving}
        className="save-events-button"
      >
        {saving ? 'Saving...' : 'Save All Events'}
      </button>
    </div>
  );
};

export default EventsEditor;